import React, { useState, useEffect, useRef } from "react";
import { FiMenu } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import GreyTable from "../../../components/Tables/GreyTable";

import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { format } from "date-fns";

import { Loader } from "../../../components/Loader/Loader";
import { FilterBox } from "../../../components/FilterBox/FilterBox";
import { QualityWiseSummery, resetQualityWiseSummery, QualityListwise } from "../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import DroupdownFilterBox from "../../../components/FilterBox/DroupdownFilterBox";
import { useTheme } from "../../../Themecontext/Themecontext";
import Calendar from "react-calendar";
import CommonCalendarStyle from "../../../components/Calendar/GreyCalenderCSS";

export const QualityWiseInOut = () => {

  const FinancialYear = Cookies.get("FinancialYear");
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [selectedProduction, setSelectedProduction] = useState("");
  const [selectedProductionId, setSelectedProductionId] = useState(null);

  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountId, setSelectedAccountId] = useState(null);

  const [selectedQuality, setSelectedQuality] = useState("");
  const [selectedQualityId, setSelectedQualityId] = useState(null);

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { mainFilterData } = useSelector((state) => state.ClientLogin);
  const { QualityWiseSummerydata, QualityListdata } = useSelector((state) => state.GreyDashboardSlice);


  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW"
  );

  const { theme } = useTheme();
  const isdark = theme;

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);


  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!mainFilterData || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    mainFilterData?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [mainFilterData, FinancialYear]);


  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;


  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  const isApiCalled = useRef(false);

  useEffect(() => {
    if (isApiCalled.current) return;

    isApiCalled.current = true;
    dispatch(QualityListwise({}))
    dispatch(
      QualityWiseSummery({
        startDate: safeFormat(startDate, "yyyy-MM-dd"),
        endDate: safeFormat(endDate, "yyyy-MM-dd"),
      })
    );
  }, [dateRange]);

  const handlesubmit = (() => {
    dispatch(resetQualityWiseSummery())
    dispatch(
      QualityWiseSummery({
        startDate: safeFormat(startDate, "yyyy-MM-dd"),
        endDate: safeFormat(endDate, "yyyy-MM-dd"),
        groupIDs: filters.production.join(","),
        partyIDs: filters.account.join(","),
        QualityIds: filters.Quality.join(",")
      })
    );
    setShowFilter(false);
  })

  const handlesubmit2 = (() => {
    dispatch(resetQualityWiseSummery())
    dispatch(
      QualityWiseSummery({
        startDate: safeFormat(startDate, "yyyy-MM-dd"),
        endDate: safeFormat(endDate, "yyyy-MM-dd"),
        // groupIDs: filters.production.join(","),
        // partyIDs: filters.account.join(","),
        QualityIds: selectedQualityId
          ? selectedQualityId.toString()
          : "",
        groupIDs: selectedProductionId
          ? selectedProductionId.toString()
          : "",
        partyIDs: selectedAccountId
          ? selectedAccountId.toString()
          : "",
      })
    );
  })

  const [filters, setFilters] = useState({
    production: [],
    account: [],
    Quality: []
  });

  const [search, setSearch] = useState({
    production: "",
    account: "",
    Quality: ""
  });

  const productionGroups =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item.ProductionGroupMstName,
      value: item.ProductionGroupMstID,
    })) || [];

  const accountList =
    mainFilterData?.account_list?.map((item) => ({
      label: item.AcName,        // 👈 check karo API me field name
      value: item.AcID,
    })) || [];

  const QualityList =
    QualityListdata?.Quality?.map((item) => ({
      label: item.ItemName,        // 👈 check karo API me field name
      value: item.ItemID,
    })) || [];


  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]:
        prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const tableData = (QualityWiseSummerydata?.data || []).map(
    (row, index) => ({

      // srNumber: index + 1,
      ItemName: row.ItemName,
      OpInwMeter: row.OpwMeter,
      InwMeter: row.InwMeter,
      FinishMeter: row.FinishMeter,
      ShortageMeter: row.ShortageMeter,
      TotalOutward: row.TotalOutward,
      BalMeter: row.BalanceMeter,
      ShortageMeter: row.ShortageMeter,
      LongeshionMeter: row.LongeshionMeter,

    })
  );

  const columns = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Quality Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: `Opening Meter`,
      key: "OpInwMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Inward Meter",
      key: "InwMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Finish Meter",
      key: "FinishMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Shortage Meter",
      key: "ShortageMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Elongation Meter",
      key: "LongeshionMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Total Outward",
      key: "TotalOutward",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    {
      label: "Balance Meter",
      key: "BalMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
  ];

  const isNoData =
    !QualityWiseSummerydata?.data ||
    QualityWiseSummerydata?.data.length === 0;

  if (!mainFilterData) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  if (QualityWiseSummerydata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }


  return (


    <>


      <div className="pageContainer">


        <div xs={4} className="d-lg-none text-end mb-3">
          <Button
            onClick={handleShow}
            style={{
              border: "none",
              backgroundColor:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              color:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
            }}
          >
            <FiMenu size={22} />
          </Button>
        </div>


        <Offcanvas show={showFilter} onHide={handleClose} placement="start"
          style={{
            background:
              isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour10,
          }}
        >
          <Offcanvas.Header closeButton
            closeVariant={isdark === "dark" ? "white" : undefined}
            style={{ color: isdark === "light" ? "#000" : "#FFF", }}
          >
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px"
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                    alignItems: "center",
                    display: "flex"
                  }}
                >
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: "1px solid #ccc",
                  padding: "15px",
                  marginBottom: "15px",
                  background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                  borderRadius: "0px 0px 12px 12px"

                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                    : "Select Date Range"}
                </div>
              </div>

            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <FilterBox
                title="Production Group"
                items={productionGroups}
                search={search.production}
                setSearch={(val) => handleSearch("production", val)}
                selectedItems={filters.production}
                toggleItem={(item) => toggleItem("production", item)}
                selectAll={() => selectAll("production", productionGroups)}
              />

              <FilterBox
                title="Account"
                items={accountList}
                search={search.account}
                setSearch={(val) => handleSearch("account", val)}
                selectedItems={filters.account}
                toggleItem={(item) => toggleItem("account", item)}
                selectAll={() => selectAll("account", accountList)}
              />


              <FilterBox
                title="Quality Name"
                items={QualityList}
                search={search.Quality}
                setSearch={(val) => handleSearch("Quality", val)}
                selectedItems={filters.Quality}
                toggleItem={(item) => toggleItem("Quality", item)}
                selectAll={() => selectAll("Quality", QualityList)}
              />
            </div>

            <button
              onClick={handlesubmit}
              className="mt-3 hover-scale-btn"
              style={{
                padding: "12px",
                backgroundColor: "rgb(64, 145, 108)",
                color: "#fff",
                width: "100%",
                border: "1px solid rgb(64, 145, 108)",
                borderRadius: "12px",
                // fontSize: "15px",
                fontWeight: "700",
                cursor: "pointer",
                boxSizing: "border-box",
              }}
            >
              Apply Filters
            </button>
          </Offcanvas.Body>
        </Offcanvas>

        <Row className="g-4 align-items-start">
          <Col xl={12} className="d-none d-lg-block">

            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour7,

                padding: "15px",
                borderRadius: "12px",
                border: `2px solid ${isdark === "light"
                  ? iscolour?.Colour4
                  : iscolourDark?.Colour3
                  }`,
              }}
            >
              <Row >


                <Col xl={3} lg={6} md={6} sm={12} >
                  <div>
                    <h3
                      style={{
                        color:
                          isdark === "light"
                            ? iscolour?.Colour3
                            : iscolourDark?.Colour2,
                        fontWeight: "700",
                        fontSize: "13px",
                        marginBottom: "5px",
                      }}
                    >
                      Date Range
                    </h3>
                  </div>
                  <div>
                    <div
                      onClick={() => setShowDatePicker(true)}
                      className="date"
                      style={{
                        // marginTop: "8px",
                        padding: " 12px 20px",
                        borderRadius: "12px",
                        cursor: "pointer",
                        textAlign: "center",
                        border: `1px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour3}`,
                        // backgroundColor: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                        color: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2
                      }}
                    >
                      {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                        ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                        : "Select Date Range"}
                    </div>
                  </div>
                </Col>
                <Col xl={3} lg={6} md={6} sm={12} >
                  <DroupdownFilterBox
                    label="Production Name"
                    data={mainFilterData?.production_Group_Master_List?.map((item) => ({
                      label: item.ProductionGroupMstName,
                      value: item.ProductionGroupMstID,
                    }))}
                    selectedValue={selectedProduction}
                    setSelectedValue={setSelectedProduction}
                    selectedId={selectedProductionId}
                    setSelectedId={setSelectedProductionId}
                    placeholder="Select Production Group(s)"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />
                </Col>
                <Col xl={3} lg={6} md={6} sm={12} className="pt-0 pt- " >

                  <DroupdownFilterBox
                    label="Account Name"
                    data={mainFilterData?.account_list?.map((item) => ({
                      label: item.AcName,
                      value: item.AcID,
                    }))}
                    selectedValue={selectedAccount}
                    setSelectedValue={setSelectedAccount}
                    selectedId={selectedAccountId}
                    setSelectedId={setSelectedAccountId}
                    placeholder="Select Account Name(s)"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}
                  />

                </Col>
                <Col xl={3} lg={6} md={6} sm={12} >
                  <DroupdownFilterBox
                    label="Quality Name"
                    data={QualityListdata?.Quality?.map((item) => ({
                      label: item.ItemName,
                      value: item.ItemID
                    }))}
                    selectedValue={selectedQuality}
                    setSelectedValue={setSelectedQuality}
                    selectedId={selectedQualityId}
                    setSelectedId={setSelectedQualityId}
                    placeholder="Select Quality Name(s)"
                    isdark={isdark}
                    iscolour={iscolour}
                    iscolourDark={iscolourDark}

                  />

                </Col>

                <Col xl={12} className="pt-3" style={{ alignItems: "end", display: "flex" }}  >
                  <button
                    onClick={handlesubmit2}
                    className="hover-scale-btn"
                    // className="mt-3"
                    style={{
                      padding: " 12px",
                      backgroundColor: "rgb(64, 145, 108)",
                      color: "#fff",
                      width: "100%",
                      border: "1px solid rgb(64, 145, 108)",
                      borderRadius: "12px",
                      // fontSize: "15px",
                      fontWeight: "700",
                      cursor: "pointer",
                      boxSizing: "border-box",
                    }}
                  >
                    Submit Filters
                  </button>
                </Col>


              </Row>
            </div>
          </Col>
          <Col xl={12} style={{ minWidth: 0 }}>


            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour8,
                  padding: "14px",
                }}
              >
                <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px",fontWeight:"700" }}>
                  QUALITYWISE IN OUT
                </h2>
              </div>
              <div >
                <GreyTable columns={columns} data={tableData} iscolourDark={iscolourDark}
                  iscolour={iscolour} />
              </div>
            </div>

          </Col>
        </Row>

      </div >
      {showDatePicker && (
        <>
          <CommonCalendarStyle
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />

          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 99999,
            }}
            onClick={() => setShowDatePicker(false)}
          >

            <div
              style={{
                background:
                  isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour7,

                borderRadius: "20px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Calendar
                className="custom-calendar"
                selectRange={true}
                onChange={(value) => {
                  if (Array.isArray(value)) {
                    setDateRange([
                      {
                        startDate: value[0],
                        endDate: value[1],
                        key: "selection",
                      },
                    ]);
                  }
                }}
                value={
                  dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? [dateRange[0].startDate, dateRange[0].endDate]
                    : null
                }
              />

              <div
                className="date-picker-footer"
                style={{
                  textAlign: "center",
                  marginTop: "15px",
                  padding: "12px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour7,
                  borderRadius: "0 0 20px 20px",
                }}
              >
                <button
                  onClick={() => setShowDatePicker(false)}
                  style={{
                    padding: "10px",
                    borderRadius: "12px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "700",
                    color: "#fff",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour3,
                    boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                    transition: "0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.opacity = "0.85";
                    e.target.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = "1";
                    e.target.style.transform = "scale(1)";
                  }}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </>
      )}

    </>

  );
};